import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import {
  useLeaveRequestsData,
  useLeaveStatus,
  useLeaveTypesData,
  useUpdateLeaveRequests,
} from "./hooks/useLeave";
import _ from "lodash";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../Component/BasicComponents/Dropdowns/RouteDropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaEdit, FaEye } from "react-icons/fa";
import { showToast } from "../../utils/toastUtils";
import { truncateSync } from "fs";
import { Btn } from "../../AbstractElements";
import { BASE_URL } from "../../Api/config";
import { downloadExcelGet } from "../../utils/ExcelDownload";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { COLORS } from "../../constants/colors";

const CustomDatepickerInput = React.forwardRef<HTMLInputElement, any>(
  ({ value, onClick, placeholder }, ref) => (
    <input
      onClick={onClick}
      ref={ref}
      value={value}
      readOnly
      placeholder={placeholder}
      style={{
        padding: "8px 12px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "14px",
        width: "100%",
        outline: "none",
        backgroundColor: "transparent",
        cursor: "pointer",
        color: "inherit",
      }}
    />
  )
);

const LeaveRequest = () => {
  const navigate = useNavigate();
  const { startPolling, stopPolling } = useExcelPolling();
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    employee_id: "",
    status: "",
    search: null,
  });
  const [isModal, setIsModal] = useState(false);
  const [leaveType, setLeaveType] = useState("");
  const [leaveFrom, setLeaveFrom] = useState("");
  const [leaveTo, setLeaveTo] = useState("");
  const [leaveReason, setLeaveReason] = useState("");
  const [leaveReqId, setLeaveReqId] = useState("");
  const [selectedLeaveRequestStatus, setSelectedLeaveRequestStatus] = useState<
    number | null
  >(null);

  const [buttonDisable, setButtonDisable] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const {
    data: leaveRequestDataa,
    isLoading: leaveRequestDataLoading,
    refetch,
  } = useLeaveRequestsData({
    enable: true,
    params: {
      page: filtersState.page,
      limit: filtersState.limit,
      leaveReqId: "",
      employee_id: "",
      status: filtersState.status,
      search: filtersState.search,
      start_date: startDateFilter,
      end_date: endDateFilter,
    },
  });
  const { data: leaveTypeDataa } = useLeaveTypesData({ enable: true });
  const { data: leaveStatus } = useLeaveStatus({ enable: true });
  const { mutate } = useUpdateLeaveRequests();

  let formattedDataleaveType = leaveTypeDataa?.data.map((item: any) => ({
    id: item?.ShortCode,
    label: item?.LeaveType,
  }));

  let formattedLeaveStatusData = Object.entries(leaveStatus?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  const toggle = () => {
    setIsModal(!isModal);
    setButtonDisable(false);
  };

  const handleFilter = (key: any, selected: any) => {
    setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : Number(selected.id),
    }));
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  // const tableBodyRef = useRef<HTMLDivElement | null>(null);

  // const scrollToBottom = () => {
  //   if (tableBodyRef.current) {
  //     tableBodyRef.current.scrollTop = tableBodyRef.current.scrollHeight;
  //   }
  // };

  const validateDates = (startDate: string, endDate: string): boolean => {
    if (startDate && endDate) {
      if (new Date(startDate) > new Date(endDate)) {
        showToast.warning("Start date should not be after end date.");
        setEndDateFilter("");
        setStartDateFilter("");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = (row: any) => {
    if (!leaveType) {
      showToast.warning("Please Fill Leave Type!");
      return;
    } else if (!leaveFrom) {
      showToast.warning("Please Fill Start Date!");
      return;
    } else if (!leaveTo) {
      showToast.warning("Please Fill End Date!");
      return;
    } else if (!leaveReason.trim()) {
      showToast.warning("Please Fill Leave Reason!");
      return;
    } else {
      const body = {
        LeaveType: selectedLeaveRequestStatus,
        LeaveFrom: leaveFrom,
        LeaveTo: leaveTo,
        LeaveReason: leaveReason,
        attachment: "",
      };
      setButtonDisable(true);
      mutate(
        { id: Number(leaveReqId), body },
        {
          onSuccess: () => {
            setIsModal(!isModal);
            setLeaveReason("");
            setLeaveFrom("");
            setLeaveTo("");
            setLeaveType("");
            setLeaveReqId("");
          },
          onError: () => {
            // setIsModal(!isModal);
            setButtonDisable(false);
          },
        }
      );
    }
  };
  // Handle filter changes

  const handleLeaveRequestView = (row: any) => {
    navigate("/leave/leaverequest/leaveview", {
      state: { leaveReqId: row?.LeaveReqId, rowData: row },
    });
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    const { value } = e.target;
    if (field === "LeaveType") setLeaveType(value);
    if (field === "LeaveFrom") setLeaveFrom(value);
    if (field === "LeaveTo") setLeaveTo(value);
    if (field === "LeaveReason") setLeaveReason(value);
  };

  const handleEditLeaveRequest = (row: any) => {
    setIsModal(!isModal);
    setLeaveType(row?.LeaveType || "");
    setLeaveFrom(row?.LeaveFrom || "");
    setLeaveTo(row?.LeaveTo || "");
    setLeaveReason(row?.LeaveReason || "");
    setLeaveReqId(row?.LeaveReqId);
    setSelectedLeaveRequestStatus(row?.LeaveType || null);
  };

  const downloadExcelGet = async () => {
    const params: Record<string, any> = {
      ...(leaveReqId ? { leaveReqId } : {}),
      ...(filtersState.employee_id
        ? { employee_id: filtersState.employee_id }
        : {}),
      ...(filtersState.status ? { status: filtersState.status } : {}),
      ...(filtersState.search ? { search: filtersState.search } : {}),
      ...(startDateFilter ? { start_date: startDateFilter } : {}),
      ...(endDateFilter ? { end_date: endDateFilter } : {}),
    };
    const queryString = new URLSearchParams(params).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.LEAVE.GET_LEAVE_REQUEST_EXCEL}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } = response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.csv";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  const formatLocalDate = (date: Date): string => {
    return date.toLocaleDateString("en-CA"); // This gives YYYY-MM-DD
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Leave Request"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        Title="Leave Request List"
        data={leaveRequestDataa?.data?.data || []}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={leaveRequestDataLoading}
        columns={leaveRequestColumns(
          handleLeaveRequestView,
          handleEditLeaveRequest
        )}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              // marginBottom: "15px",
            }}
          >
            {/* Status Dropdown */}
            <RoundedDropdown
              options={formattedLeaveStatusData || []}
              onSelect={(e) => handleFilter("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Leave Status"
              headingColor="#2e8dd3"
            />

            {/* Start Date Filter */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  color: "#2e8dd3",
                  fontWeight: "600",
                  marginRight: "10px",
                  textAlign: "center",
                }}
              >
                Start Date
              </label>
              <DatePicker
                selected={startDateFilter ? new Date(startDateFilter) : null}
                onChange={(date: Date | null) => {
                  const formattedDate = date ? formatLocalDate(date) : "";
                  setStartDateFilter(formattedDate);
                  validateDates(formattedDate, endDateFilter);
                }}
                customInput={<CustomDatepickerInput />}
                placeholderText="Select Start Date"
                dateFormat="yyyy-MM-dd"
                popperPlacement="bottom"
                popperContainer={(state: any) => (
                  <div style={{ position: "absolute", zIndex: 9999 }}>
                    {state.children}
                  </div>
                )}
                renderDayContents={(day, date) => {
                  const today = new Date();
                  const isCurrentMonth =
                    date.getMonth() === today.getMonth() &&
                    date.getFullYear() === today.getFullYear();

                  const isSelected =
                    startDateFilter &&
                    new Date(startDateFilter).toDateString() ===
                      date.toDateString();

                  const isHighlightedToday =
                    !startDateFilter &&
                    date.toDateString() === today.toDateString();

                  const isActive = isSelected || isHighlightedToday;

                  return (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "30px",
                        height: "30px",
                        borderRadius: isActive ? "4px" : "50%",
                        fontWeight: isCurrentMonth ? "bolder" : "normal",
                        color: isActive ? "#43bab2" : "#636e72",
                        fontSize: isCurrentMonth ? "16px" : "14px",
                        backgroundColor: isActive
                          ? "#f6b93b" // highlight for selected/today
                          : isCurrentMonth
                          ? "#ffffff" // white for current month dates
                          : "transparent", // no color for other months
                      }}
                    >
                      {day}
                    </span>
                  );
                }}
              />
            </div>

            {/* End Date Filter */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  color: "#2e8dd3",
                  fontWeight: "600",
                  marginRight: "10px",
                  textAlign: "center",
                }}
              >
                End Date
              </label>
              <DatePicker
                selected={endDateFilter ? new Date(endDateFilter) : null}
                onChange={(date: Date | null) => {
                  const formattedDate = date ? formatLocalDate(date) : "";
                  setEndDateFilter(formattedDate);
                  validateDates(startDateFilter, formattedDate);
                }}
                // maxDate={new Date()}
                placeholderText="Select End Date"
                customInput={<CustomDatepickerInput />}
                dateFormat="yyyy-MM-dd"
                popperPlacement="bottom" // Ensure calendar is placed below the input field
                popperContainer={(state: any) => (
                  <div style={{ position: "absolute", zIndex: 9999 }}>
                    {state.children} {/* Use `children` instead of `popper` */}
                  </div>
                )}
                renderDayContents={(day, date) => {
                  const today = new Date();
                  const isCurrentMonth =
                    date.getMonth() === today.getMonth() &&
                    date.getFullYear() === today.getFullYear();

                  const isSelected =
                    endDateFilter &&
                    new Date(endDateFilter).toDateString() ===
                      date.toDateString();

                  const isHighlightedToday =
                    !endDateFilter &&
                    date.toDateString() === today.toDateString();

                  const isActive = isSelected || isHighlightedToday;

                  return (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "30px",
                        height: "30px",
                        borderRadius: isActive ? "4px" : "50%",
                        fontWeight: isCurrentMonth ? "bolder" : "normal",
                        color: isActive ? "#43bab2" : "#636e72",
                        fontSize: isCurrentMonth ? "16px" : "14px",
                        backgroundColor: isActive
                          ? "#f6b93b" // highlight for selected/today
                          : isCurrentMonth
                          ? "#ffffff" // white for current month dates
                          : "transparent", // no color for other months
                      }}
                    >
                      {day}
                    </span>
                  );
                }}
              />
            </div>
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          leaveRequestDataa?.data?.pagination?.total_records || 0
        }
      />
      {/* <div ref={tableEndRef}></div> */}
      <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isModal}
        title="Edit Leave Request"
        content={
          <>
            <ReusableDropdown
              options={formattedDataleaveType || []}
              onChange={(value: any) => {
                console.log("Selected leave type:", value);
                setSelectedLeaveRequestStatus(value); // Store only the ID as a number
              }}
              DropdownHeading="Leave Type"
              asterisk={true}
              value={selectedLeaveRequestStatus?.toString()}
            />
            <CustomInput
              label="Reason"
              asterisk={true}
              type="textarea"
              value={leaveReason}
              style={{
                backgroundColor: "transparent",
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
              // onChange={(e) => handleChange(e, "LeaveFrom")}
              onChange={(e) => handleChange(e, "LeaveReason")}
            />
            <CustomInput
              label="Start Date"
              asterisk={true}
              type="date"
              value={leaveFrom}
              style={{
                backgroundColor: "transparent",
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
              // onChange={(e) => handleChange(e, "LeaveTo")}
              onChange={(e) => handleChange(e, "LeaveFrom")}
            />
            <CustomInput
              label="End Date"
              type="date"
              asterisk={true}
              value={leaveTo}
              style={{
                backgroundColor: "transparent",
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
              // onChange={(e) => handleChange(e, "LeaveReason")}
              onChange={(e) => handleChange(e, "LeaveTo")}
            />
            <div>
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
                disabled={buttonDisable}
                onClick={handleSubmit}
              >
                Update
              </Btn>

              <button
                onClick={() => {
                  setIsModal(!isModal);
                  setButtonDisable(false);
                }}
                className="btn btn-light"
                style={{ color: "gray", marginLeft: "10px" }}
              >
                Cancel
              </button>
            </div>
          </>
        }
      />
    </div>
  );
};

export default LeaveRequest;

// Table Columns
const leaveRequestColumns = (
  handleLeaveRequestView: (row: any) => void,
  handleEditLeaveRequest: (row: any) => void
) => [
  {
    name: "Request ID",
    selector: (row: { LeaveReqId: string }) => row.LeaveReqId ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "Org Unit",
    selector: (row: { OrgUnit: string }) => row?.OrgUnit ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "Emp Name",
    selector: (row: { FirstName: string; LastName: string }) =>
      `${row.FirstName ?? ""} ${row.LastName ?? ""}`.trim() || "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "Emp Code",
    selector: (row: { EmployeeCode: string }) => row.EmployeeCode ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
    sortFunction: (a: any, b: any) => {
      return Number(a.EmployeeCode) - Number(b.EmployeeCode);
    },
  },

  {
    name: "HQ",
    selector: (row: { HQ: string }) => row.HQ ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "Leave Type",
    selector: (row: { LeaveType: string }) => row.LeaveType ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "Leave Status",
    selector: (row: { LeaveStatusName: string }) => row.LeaveStatusName ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "Start Date",
    selector: (row: { LeaveFrom: string }) => row.LeaveFrom ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "End Date",
    selector: (row: { LeaveTo: string }) => row.LeaveTo ?? "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },
  {
    name: "Requested Date",
    selector: (row: { CreatedAt: string }) =>
      row.CreatedAt ? row.CreatedAt.split(" ")[0] : "-",
    sortable: true,
    minWidth: "170px",
    wrap: true,
  },

  {
    name: "Actions",
    cell: (row: any) => (
      <>
        <button
          onClick={() => handleEditLeaveRequest(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "2px",
          }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
        <button
          onClick={() => handleLeaveRequestView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            marginLeft: "5px",
          }}
        >
          <FaEye style={{ fill: "#fff" }} /> View
        </button>
      </>
    ),
  },
];
